export default __webpack_public_path__ + "static/media/delete-button.a43d6d55.svg";